module.exports = __webpack_public_path__ + "img/discussion1.aed2bd2b.svg";